import {
  faHome,
  faChartBar,
  faCreditCard,
  faBullhorn,
  faTicket,
  faUser,
  faPodcast,
  faUsers,
  faDiagramProject,
  faStar,
  faDollarSign,
  faSatelliteDish,
  faShieldHalved,
  faPercent
} from '@fortawesome/free-solid-svg-icons'

export const NAVIGATION_SECTIONS = [
  {
    title: 'MAIN',
    items: [
      { name: 'Lobbies', path: '/lobbies', icon: faHome, requiredPermission: 'read-lobby' },
      { name: 'En Vivo', path: '/live', icon: faSatelliteDish, requiredPermission: 'read-lobby' }
    ]
  },
  {
    title: 'SOPORTE',
    items: [
      { name: 'Buscar usuario', path: '/user-search', icon: faUser, requiredPermission: 'read-user' },
      { name: 'Pagos pendientes', path: '/driver-payments', icon: faCreditCard, requiredPermission: 'driver-payments' },
      { name: 'Revisión de payouts', path: '/payout-review', icon: faShieldHalved, requiredPermission: 'driver-payments' },
      { name: 'Cupones', path: '/coupons', icon: faTicket, requiredPermission: 'coupons' },
      { name: 'CRM', path: '/crm-users', icon: faDiagramProject, collapseOnSelect: true, requiredPermission: 'read-crm' }
    ]
  },
  {
    title: 'MARKETING',
    items: [
      { name: 'Chat Broadcast', path: '/chat-broadcast', icon: faPodcast, requiredPermission: 'broadcast' },
      { name: 'Popup', path: '/news-popup', icon: faBullhorn, requiredPermission: 'broadcast' },
      { name: 'Importar Cohort', path: '/import-cohort', icon: faUsers, requiredPermission: 'broadcast' },
      { name: 'Influencers', path: '/influencers', icon: faStar, requiredPermission: 'influencers' }
    ]
  },
  {
    title: 'ANALYTICS',
    items: [
      { name: 'Liquidity', path: '/liquidity', icon: faChartBar, requiredPermission: 'statistics' }
    ]
  },
  {
    title: 'CONFIG',
    items: [
      { name: 'Precios', path: '/pricing', icon: faDollarSign, requiredPermission: 'read-pricing' },
      { name: 'Descuentos', path: '/discounts', icon: faPercent, requiredPermission: 'discounts' }
    ]
  }
]

export const MOBILE_NAVIGATION_SECTIONS = [
  {
    title: 'MAIN',
    items: [
      { name: 'Lobbies', path: '/lobbies', icon: faHome, requiredPermission: 'read-lobby' },
      { name: 'En Vivo', path: '/live', icon: faSatelliteDish, requiredPermission: 'read-lobby' }
    ]
  },
  {
    title: 'SOPORTE',
    items: [
      { name: 'Buscar usuario', path: '/user-search', icon: faUser, requiredPermission: 'read-user' },
      { name: 'CRM', path: '/crm-users', icon: faUsers, requiredPermission: 'read-crm' },
      { name: 'Pagos pendientes', path: '/driver-payments', icon: faCreditCard, requiredPermission: 'driver-payments' },
      { name: 'Revisión de payouts', path: '/payout-review', icon: faShieldHalved, requiredPermission: 'driver-payments' },
      { name: 'Cupones', path: '/coupons', icon: faTicket, requiredPermission: 'coupons' }
    ]
  },
  {
    title: 'MARKETING',
    items: [
      { name: 'Chat Broadcast', path: '/chat-broadcast', icon: faPodcast, requiredPermission: 'broadcast' },
      { name: 'Popup', path: '/news-popup', icon: faBullhorn, requiredPermission: 'broadcast' },
      { name: 'Importar Cohort', path: '/import-cohort', icon: faUsers, requiredPermission: 'broadcast' },
      { name: 'Influencers', path: '/influencers', icon: faStar, requiredPermission: 'influencers' }
    ]
  },
  {
    title: 'ANALYTICS',
    items: [
      { name: 'Liquidity', path: '/liquidity', icon: faChartBar, requiredPermission: 'statistics' }
    ]
  },
  {
    title: 'CONFIG',
    items: [
      { name: 'Precios', path: '/pricing', icon: faDollarSign, requiredPermission: 'read-pricing' },
      { name: 'Descuentos', path: '/discounts', icon: faPercent, requiredPermission: 'discounts' }
    ]
  }
]
